export default __webpack_public_path__ + "static/media/estoque.10140c57.svg";